const exampleNumberValues = 30;

const createATE = (label: string, id: number) => {
  return {
    id,
    label,
  };
};

export const exampleATE = new Array(exampleNumberValues)
  .fill(null)
  .map((_, index) => createATE('ATE ' + ++index, ++index));

export const exampleParams = new Array(exampleNumberValues)
  .fill(null)
  .map((_, index) => createATE('Параметр ' + ++index, ++index));
